// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import constants from "@store/constants";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React, { FC } from "react";

export interface InviteYourColleagueHeaderProps extends WidgetProps {}

export interface InviteYourColleagueHeaderStyles {}

export const inviteYourColleagueHeaderHeaderStyles: InviteYourColleagueHeaderStyles = {};

const InviteYourColleagueHeader: FC<InviteYourColleagueHeaderProps> = ({ id }) => {
    const currentPage = useCurrentPage();

    return (
        <OrderHeader title={currentPage.fields.title} isV2>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: InviteYourColleagueHeader,
    definition: {
        group: constants.widgetGroup.inviteYourColleague,
        displayName: "Header",
        allowedContexts: [constants.pageType.inviteYourColleague, constants.pageType.notificationPreferences],
    },
};

export default widgetModule;
